import Immutable from 'immutable';
import Resource from '../../resource/Resource';

import {
  UPDATE_GROUP_TYPES,
  SET_GROUP_TYPE,
  DELETE_GROUP_TYPE,
} from './actions';

export function setGroupTypes(groupTypes) {
  return (dispatch) => {
    dispatch({
      type: UPDATE_GROUP_TYPES,
      groupTypes,
    });
  };
}

export function createGroupType(groupType, resolve, reject) {
  return (dispatch) => {
    Resource.create('groupType', groupType.toJS(), ['resource'])
      .then((response) => {
        dispatch({
          type: UPDATE_GROUP_TYPES,
          groupTypes: [response[0]],
        });
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error creating group type',
          message: response.reason,
        });
      });
  };
}

export function updateGroupType(groupType, resolve, reject) {
  return (dispatch) => {
    Resource.update(
      'groupType',
      groupType.get('id'),
      'updateGroupType',
      groupType.toJS()
    )
      .then((response) => {
        dispatch({
          type: SET_GROUP_TYPE,
          groupType: Immutable.fromJS(response),
        });
        resolve();
      })
      .fail((result, response) => {
        reject({
          title: 'Error updating group type',
          message: response.reason,
        });
      });
  };
}

export function deleteGroupType(groupType, deleteGroups, resolve, reject) {
  return (dispatch) => {
    Resource.update('groupType', groupType.get('id'), 'deleteGroupType', {
      deleteGroups,
    })
      .then((response) => {
        if (response.isDeleted) {
          dispatch({
            type: DELETE_GROUP_TYPE,
            groupType,
          });
          resolve();
        } else {
          reject({
            title: 'Error deleting group type',
            message: `There was a problem deleting group type: '${groupType.get(
              'name'
            )}'`,
          });
        }
      })
      .fail((result, response) => {
        reject({
          title: 'Error deleting group type',
          message: response.reason,
        });
      });
  };
}
